import { ChainId } from '@/lib/chain'
import { TEnvConfig } from './env.interfact'
import { PROD_CONFIG } from './prod'

export const BETA_CONFIG: TEnvConfig = {
  ...PROD_CONFIG,
  amplitudeApiKey: '5fc3dae2d16504b413bd010d4978e8ae',
  supportedChains: [ChainId.ETHEREUM, ChainId.OPTIMISM, ChainId.BSC],
  defaultChainId: ChainId.OPTIMISM,
  kulapPlusApiBaseUrl: 'https://beta-plus-api.kulap.io/api/v1',
  kulapPlusUtilityFileUrl:
    'https://kulap-plus-utility-file-beta.s3.ap-southeast-1.amazonaws.com',
  kulapPlusTokenListFilePath: {
    [ChainId.ETHEREUM]: '/token-lists/ethereum.json',
    [ChainId.OPTIMISM]: '/token-lists/optimism.json',
    [ChainId.BSC]: '/token-lists/bsc.json'
  },
  kulapSwapFrontendUrl: 'http://alpha.kulap.io',
  kulapPlusFrontendUrl: 'https://beta-app.kulap.io',
  googleRecaptcha: '6Ld_pMUZAAAAAM5Pajn7kxKwQRbJGoqIRb3axu7Y',
  facebookAppId: '2228084830653503',
  initFromFiatCurrencyAmount: '17',
  checkUserEligibilityTrade: false,
  depositSwapContractAddresses: {
    [ChainId.ETHEREUM]: '0x4715DAE833608FE3667DE8464a3074410E3441b8',
    [ChainId.BSC]: '0x0378d401092372701fB275bf45f246114aD50704',
    [ChainId.OPTIMISM]: '0x848d0429F8ED25f437285A4605cD7E281f1482a6'
  },
  thaiD: {
    apiEndpoint: 'https://imauth.bora.dopa.go.th/api/v2',
    clientId: 'bDNWUDBJYVNJVE4xNDhPRUhsTDdZSXNRM0RLZzl6WE4',
    redirectUri:
      'https://beta-plus-api.kulap.io/api/v1/kyc-provider/thaid/callback'
  }
}
